import type { FunctionComponent } from "react";
import { AddFixedPayoutSliderMenuPartial } from "../../../../partials/admin/menus/campaign/add-fixed-payout-slider.admin.partials";

export const AddFixedPayoutSliderMenuAdminScreen: FunctionComponent = () => {
    return <AddFixedPayoutSliderMenuPartial />;
};
